import { Anchor, Select } from "@mantine/core";
import { useState } from "react";
import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { backendUrl } from "../../constants";
import logo from "../../assets/Youtube.svg";
import "./styles.css";
import { showNotification } from "@mantine/notifications";

const BlockUser = ({ setBlockUser, refetch }) => {
  let user = JSON.parse(localStorage.getItem("userData")).id;
  const [users, setUsers] = useState([]);
  const [reload, setReload] = useState(false);
  const [blockList, setBlockedList] = useState([]);

  //users
  useEffect(() => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({}),
    };
    fetch(`${backendUrl}user/searchJobSeeker`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            value: obj._id,
            label: obj.displayName,
          };
          setUsers((u) => [...u, a]);
        });
      })
      .catch((err) => {});
  }, []);

  //blocked list
  useEffect(() => {
    setBlockedList([]);
    const options = {
      method: "GET",
    };
    fetch(`${backendUrl}user/getBlockedList/${user}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data[0].blockedUsers.map((obj) => {
          setBlockedList((u) => [...u, obj?.user]);
        });
      })
      .catch((err) => {});
  }, [reload, user, refetch]);

  const handleUnblocK = (blockUserId) => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({ userId: user, blockUserId: blockUserId }),
    };

    fetch(`${backendUrl}user/UnBlockUser`, options)
      .then((response) => response.json())
      .then((response) => {
        showNotification({
          title: "Unblocked",
          message: "User Unblocked Successfully!",
          color: "green",
        });
        setReload(!reload);
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="d-flex flex-column gap-2 px-5">
      <h5 className="text-dark text-center">Blocked Users</h5>
      <Select
        placeholder="Block User"
        data={users}
        // searchable
        maxDropdownHeight={400}
        onChange={(v) => setBlockUser((a) => ({ ...a, blockUserId: v }))}
      />
      <h6 className="text-dark text-center">Blocked List</h6>
      {blockList.map((obj, key) => (
        <div className="blocked-user" key={key}>
          <img
            src={obj?.jobSeeker?.[0]?.jobSeekerProfileImage}
            width="30px"
            height={"30px"}
            className='rounded-circle'
          />
          <div>
            <h6 className="mb-0">{obj?.firstName + " " + obj?.lastName}</h6>
            <p className="mb-0">{obj?.jobSeeker[0]?.jobTitle}</p>
          </div>
          <Anchor
            style={{ marginLeft: "auto" }}
            onClick={() => handleUnblocK(obj._id)}
          >
            Unblock
          </Anchor>
        </div>
      ))}

      {/* {blockList.map((obj) => obj)} */}
    </div>
  );
};
export default withTranslation()(BlockUser);
